<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-lg-12 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import slugify from 'slugify'
import { TYPES as TASK_TAG_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'TaskTagEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Tag',
      rolePerm: 'tasks_tasktag_retrieve',
      editRolePerm: 'tasks_tasktag_update'
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_TAG_TYPES.GENERIC.task['task-tag'].DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...TASK_TAG_TYPES.GENERIC.task['task-tag'].DETAIL.ACTIONS
    }),
    getFormData () {
      const data = Object.assign({}, this.form)
      if (!this.id && data.name) {
        data.slug = slugify(data.name, { remove: /[*+~.()'"!:@]/g })
      }
      return data
    }
  },
  validations: {
    form: {
      name: { required }
    }
  }
}
</script>
